import { useAtom, useSetAtom } from "jotai";
import { selectedAccountAtom, showCommitPanelAtom } from "../Labeling.state";
import { rightDrawerOpenAtom } from "@/features/Navigation/state";
import { useCallback } from "react";
import { useDraft } from "./useDraft";
import { DraftAccount } from "@/entities/DataAssociation/Draft.model";
import { CellClickedEvent } from "ag-grid-enterprise";
import { isRowDisabled } from "../Labeling.helpers";

export function useRowSelection() {
    const [selectedAccountRow, setSelectedAccountRow] =
        useAtom(selectedAccountAtom);
    const setRightDrawerOpen = useSetAtom(rightDrawerOpenAtom);
    const setShowCommitPanel = useSetAtom(showCommitPanelAtom);
    const { applyAccount, isReadonly, isCodat } = useDraft();

    const onAccountSelection = useCallback(
        (account: DraftAccount) => {
            if (!selectedAccountRow) return;
            applyAccount(selectedAccountRow.rowIndex, account);
            setSelectedAccountRow(null);
            setRightDrawerOpen(false);
        },
        [
            setSelectedAccountRow,
            setRightDrawerOpen,
            applyAccount,
            selectedAccountRow,
        ],
    );

    const onRowClicked = useCallback(
        (event: CellClickedEvent) => {
            if (
                !(
                    event.colDef.colId === "label" ||
                    event.colDef.colId === "accountName"
                ) ||
                isReadonly
            ) {
                return;
            }

            if (
                isRowDisabled(isCodat, event.data.account?.meta?.codatAccountId)
            )
                return;

            setShowCommitPanel(false);
            setSelectedAccountRow(() => ({
                account: event.data.account,
                rowHeader: event.data.rowHeader,
                rowIndex: event.data.rowIndex,
            }));
            setRightDrawerOpen(true);
        },
        [
            setShowCommitPanel,
            setRightDrawerOpen,
            setSelectedAccountRow,
            isReadonly,
            isCodat,
        ],
    );

    return {
        selectedAccountRow,
        setSelectedAccountRow,
        onAccountSelection,
        onRowClicked,
    };
}
